export default {
  'channelOnboarding.back': 'Back',
  'channelOnboarding.description':
    'Unified registration for commercial channel actors in a single transaction.',

  'channelOnboarding.fields.entityType': 'Registration type',
  'channelOnboarding.fields.automyPlan': 'AUTOMY plan',
  'channelOnboarding.fields.billingMode': 'Billing mode',
  'channelOnboarding.fields.identity': 'Tax ID / Identity',
  'channelOnboarding.sections.companyData': 'Company details',
  'channelOnboarding.sections.ownerUser': 'Primary administrator',
  'channelOnboarding.fields.ownerUser.lastNames': 'Last name',
  'channelOnboarding.fields.ownerUser.invitationHint':
    'An activation invitation will be sent to this email if registration completes. If it stays pending AUTOMY approval, no invitation is sent until AUTOMY approves it.',

  'channelOnboarding.steps.entityType.title': 'Registration type',
  'channelOnboarding.steps.entityType.hint':
    'Choose the actor type. Fields and validations change based on your selection.',
  'channelOnboarding.steps.plan.title': 'AUTOMY plan',
  'channelOnboarding.steps.plan.hint':
    'Select an active plan for the company being created. The billing subscription is created automatically.',
  'channelOnboarding.steps.plan.billingModeHint':
    'The plan defines price and features. The billing mode defines how this company subscription will be activated.',
  'channelOnboarding.steps.company.title': 'Company',
  'channelOnboarding.steps.actor.title': 'Channel actor',
  'channelOnboarding.steps.agreement.title': 'Commercial agreement',
  'channelOnboarding.steps.agreement.hint':
    'Only approved agreements are listed. An agreement is required. If none are approved, create one or wait for AUTOMY review.',
  'channelOnboarding.steps.billing.title': 'Billing',
  'channelOnboarding.steps.billing.hint':
    'Optional fiscal and contact details for the billing subscription.',
  'channelOnboarding.steps.billing.hintManualInvoice':
    'With manual invoicing, legal name, tax ID, and billing email are required.',
  'channelOnboarding.steps.summary.title': 'Summary',

  'channelOnboarding.fields.canCreateDistributors': 'Can create distributors',
  'channelOnboarding.fields.parentActorKind': 'Commercial parent type',
  'channelOnboarding.fields.parentActorKind.hint':
    'If you do not choose a parent, this actor will not sit under anyone else. You can assign a parent from a higher level, for example a Distributor for a Reseller.',
  'channelOnboarding.fields.parentActorCompanyId': 'Parent company',

  'channelOnboarding.actions.confirmRegister': 'Confirm registration',
  'channelOnboarding.actions.registerAnother': 'Register another actor',

  'channelOnboarding.registrationSummary.title': 'Registration complete',
  'channelOnboarding.registrationSummary.subtitle':
    'The company was created successfully. Review the consolidated registration summary.',
  'channelOnboarding.registrationPending.title': 'Pending AUTOMY review',
  'channelOnboarding.registrationPending.subtitle':
    'Registration is pending AUTOMY approval. No invitation was sent and access is not enabled yet.',
  'channelOnboarding.registrationPending.approvalRequestId': 'Approval request: {id}',
  'channelOnboarding.registrationRejected.title': 'Registration rejected',
  'channelOnboarding.registrationRejected.subtitle':
    'AUTOMY rejected this registration. No invitation was sent and access was not enabled.',
  'channelOnboarding.registrationSummary.loadError':
    'Could not load the registration summary. Please try again.',
  'channelOnboarding.registrationSummary.sections.company': 'Company',
  'channelOnboarding.registrationSummary.sections.channelProfile': 'Commercial profile',
  'channelOnboarding.registrationSummary.sections.channelEntity': 'Channel actor',
  'channelOnboarding.registrationSummary.sections.billingSubscription': 'Billing subscription',
  'channelOnboarding.registrationSummary.sections.aiBillingProfile': 'AI billing',
  'channelOnboarding.registrationSummary.sections.defaultEnvironment': 'Default environment',
  'channelOnboarding.registrationSummary.fields.agreementId': 'Commercial agreement',
  'channelOnboarding.registrationSummary.fields.budgetEnabled': 'Budget enabled',
  'channelOnboarding.registrationSummary.fields.environmentType': 'Environment type',
  'channelOnboarding.registrationSummary.fields.isDefault': 'Default',
  'channelOnboarding.registrationSummary.fields.isPublic': 'Public',

  'channelOnboarding.progress.title': 'Registration progress',
  'channelOnboarding.step.inProgress': 'In progress',

  'channelOnboarding.errors.selectEntityTypeFirst': 'Select a registration type first.',
  'channelOnboarding.errors.duplicateIdentity': 'This identity is already in use.',
  'channelOnboarding.errors.planNotAllowedForActor':
    'The selected plan is not allowed for this actor type.',
  'channelOnboarding.errors.parentActorPairIncomplete':
    'Select both parent type and parent company, or leave both empty.',
  'channelOnboarding.errors.noRegistrationOptions':
    'No registration types are available for the active company.',
  'channelOnboarding.sections.actorsWithEntity': 'Channel actors',
  'channelOnboarding.sections.actorsWithoutEntity': 'Actors without a channel entity',
  'channelOnboarding.summary.operatingCompany': 'Operating company',
  'channelOnboarding.summary.invitation': 'Invitation',
  'channelOnboarding.summary.parentActorNone': 'Will not sit under anyone else',
};
